<template>
  <div class="flex flex-col justify-between flex-1">
    <div class="divide-y divide-gray-200">
      <div class="pt-6 pb-5 space-y-6">
        <div v-if="!hideFilters" class="mb-10">
          <div class="text-xl font-medium relative top-4">
            {{ $t("Group Filter") }}:
          </div>
          <AdvancedMetricsFilterForm :initial-filter="filter" :object-type="objectType" @update="handleUpdateFilter" />
        </div>
        <Form v-slot="{ values }" :initial-values="initial_values" :validation-schema="schema" class="mt-2 space-y-6">
          <div class="-space-y-px rounded-md shadow-sm">
            <TextInput label="" name="name" type="text" :placeholder="$t('Group name')" />
          </div>
          <div class="-space-y-px rounded-md shadow-sm">
            <SelectInput
              label-attr="label"
              :allow-null="false"
              :value="group_types[0].value"
              value-attr="value"
              :label="$t('Group type')"
              name="is_public"
              :items="group_types"
              :placeholder="$t('Group type')"
              input-classes="text-left" />
          </div>
          <div class="-space-y-px rounded-md shadow-sm">
            <TextArea label=""
                      input-classes="h-48 "
                      name="description"
                      type="text"
                      :placeholder="$t('Description')" />
          </div>
          <div class="flex flex-row justify-end w-full gap-2">
            <button type="button" class="w-fit m-0 text-light-brand-blue" @click="$emit('cancel')">{{ $t("Cancel") }}</button>
            <button v-if="selectedGroup" type="submit" class="w-fit primary-btn" @click="saveAsAnotherGroup(values)">
              {{ $t("Save as another") }}
            </button>
            <button type="submit" class="w-fit primary-btn" @click="createGroup(values)">
              {{ selectedGroup ? $t("Update") : $t("Create") }} {{ $t("Group") }}
            </button>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import * as Yup from "yup"
import TextInput from "@/components/shared/TextInput.vue"
import SelectInput from "@/components/shared/SelectInput.vue"
import TextArea from "@/components/shared/TextArea.vue"
import { Form } from "vee-validate"
import dataService from "@/services/data.service"
import { utils } from "@/store/helpers"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
import AdvancedMetricsFilterForm from "@/components/forms/AdvancedMetricsFilterForm.vue"
import { transformMetricFilterToServerFilter } from "@/services/data.transformers"

export default {
  components: {
    TextInput,
    Form,
    TextArea,
    SelectInput,
    AdvancedMetricsFilterForm
  },
  props: {
    filter: {
      type: String,
      required: true
    },
    objectType: {
      type: String,
      required: true
    },
    selectedGroup: {
      type: Object,
      required: false
    },
    hideFilters: {
      type: Boolean,
      default: false
    }
  },
  emits: ["cancel", "submitted", "done"],
  setup(props) {
    const schema = Yup.object().shape({
      name: Yup.string().required(),
      description: Yup.string(),
      is_public: Yup.mixed().oneOf(["true", "false"]),
      filter: Yup.array().of(Yup.string()),
      object_type: Yup.string()
    })
    const initial_values = {
      name: "",
      description: "",
      is_public: "true",
      object_type: utils.getObjectTypeByType(props.objectType).id,
      filter: props.filter
    }
    if (props.selectedGroup) {
      initial_values.name = props.selectedGroup.name
      initial_values.description = props.selectedGroup.description
      initial_values.is_public = props.selectedGroup.is_public
    }
    return {
      initial_values,
      schema
    }
  },

  data() {
    return {
      group_types: [
        { label: this.$t("Public"), value: "true" },
        { label: this.$t("Private (Me)"), value: "false" }
      ],
      server_filter: null
    }
  },

  activated() {},
  methods: {
    handleUpdateFilter(filter) {
      const filter_cleaned = []
      filter.forEach((item) => {
        if (item.data_type == "String") {
          if (Array.isArray(item.value)) {
            item.value = String(item.value)
          }
          // let value = item.value.replace(/[']+/g, "")
          filter_cleaned.push({ ...item, value: item.value == null ? "" : item.value.trim() })
        } else {
          if (
            item.value == null ||
            item.value == undefined ||
            item.value == "" ||
            item.value == "null" ||
            item.value == "undefined" ||
            item.value == "None"
          ) {
            item.value = null
          } else if (
            (item.data_type == "Date" || item.data_type == "DateTime") &&
            !(
              item.operator.value == "__DAYS_WITHIN_LAST_X_DAYS__" ||
              item.operator.value == "__DAYS_MORE_THAN_X_DAYS_AGO__" ||
              item.operator.value == "__DAYS_EXACT_DAYS_AGO__" ||
              item.operator.value == "__DAYS_MORE_THAN_X_DAYS_FROM_NOW__" ||
              item.operator.value == "__DAYS_WITHIN_NEXT_X_DAYS__" ||
              item.operator.value == "__DAYS_EXACT_DAYS_FROM_NOW__"
            )
          ) {
            item.value = this.$moment(item.value).format("YYYY-MM-DD")
          } else if (
            item.data_type == "DateTime" &&
            !(
              item.operator.value == "__DAYS_WITHIN_LAST_X_DAYS__" ||
              item.operator.value == "__DAYS_MORE_THAN_X_DAYS_AGO__" ||
              item.operator.value == "__DAYS_EXACT_DAYS_AGO__" ||
              item.operator.value == "__DAYS_MORE_THAN_X_DAYS_FROM_NOW__" ||
              item.operator.value == "__DAYS_WITHIN_NEXT_X_DAYS__" ||
              item.operator.value == "__DAYS_EXACT_DAYS_FROM_NOW__"
            )
          ) {
            item.value = this.$moment(item.value).format("YYYY-MM-DDTHH:mm:ss")
          }
          filter_cleaned.push({ ...item, value: item.value })
        }
      })
      let parsed_filter = transformMetricFilterToServerFilter([...filter_cleaned])

      this.server_filter = parsed_filter.filter
    },

    createGroup(values) {
      const values_copy = this.$utils.clone(values)
      values_copy["filter"] = this.server_filter ? this.server_filter : this.filter
      if (this.selectedGroup) {
        dataService.updateGroup(this.selectedGroup.id, values_copy).then((res) => {
          this.$store.dispatch("data/getGroups")
          this.$emit("done", res.data)
        })
      } else {
        values_copy["filter"] = this.server_filter ? this.server_filter : this.filter
        dataService.createGroup(values_copy).then((res) => {
          this.$store.dispatch("data/getGroups")
          this.$emit("done", res.data)
          this.$emitter.emit(ALL_EMITTERS.NEW_GROUP_CREATED_IN_OBJECT_VIEW, res.data)
        })
      }
    },
    saveAsAnotherGroup(values) {
      const values_copy = this.$utils.clone(values)
      values_copy["filter"] = this.server_filter ? this.server_filter : this.filter
      values_copy["object_type"] = this.$utils.getObjectTypeByType(this.selectedGroup.type).id
      dataService.createGroup(values_copy).then((res) => {
        this.$store.dispatch("data/getGroups")
        this.$emit("done", res.data)
        this.$emitter.emit(ALL_EMITTERS.NEW_GROUP_CREATED_IN_OBJECT_VIEW, res.data)
      })
    }
  }
}
</script>
